import moment from 'moment';
import { AssemblyType } from '../../enums/AssemblyType';
import { ShopLocation } from '../../models/ShopLocation';

export const assemblyTypeOptions = [
  { key: `${AssemblyType.All}`, text: 'Todas (interna e externa)' },
  { key: `${AssemblyType.Internal}`, text: 'Interna' },
  { key: `${AssemblyType.External}`, text: 'Externa' },
  { key: `${AssemblyType.InternalWithoutAssembler}`, text: 'Interna sem montador' }
];

export const yesNoOptions = [
  { key: '', text: 'Selecione' },
  { key: 'true', text: 'Sim' },
  { key: 'false', text: 'Não' }
];

export enum YesNoFilter {
  All = 'all',
  Yes = 'yes',
  No = 'no'
}

export const yesNoFilterOptions = [
  { key: YesNoFilter.All, text: 'Todas' },
  { key: YesNoFilter.Yes, text: 'Sim' },
  { key: YesNoFilter.No, text: 'Não' }
];

export interface IFilterToListLocationsOutput {
  text?: string;
  omnichannel?: YesNoFilter;
  manageOrderInSislog?: YesNoFilter;
  transactionalCommunication?: YesNoFilter;
}

export const defaultLocationFilter: IFilterToListLocationsOutput = {};

export const getAssemblyTypeText = (assemblyType?: AssemblyType | null) =>
  assemblyType === undefined || assemblyType === null
    ? ''
    : assemblyTypeOptions.find(option => option.key === `${assemblyType}`)?.text || `${assemblyType}`;

export const getYesNoText = (value?: boolean | null) =>
  value === true ? 'Sim' : value === false ? 'Não' : '';

export const formatDate = (value?: string | Date | null) =>
  value ? moment(value).format('DD/MM/YYYY') : '';

export const formatDateTime = (value?: string | Date | null) =>
  value ? moment(value).format('DD/MM/YYYY HH:mm') : '';

export const formatDays = (value?: number | null) =>
  value === undefined || value === null ? '' : `${value} ${value === 1 ? 'dia' : 'dias'}`;

// a API grava as datas no horário local (America/Sao_Paulo), sem fuso: não usar toISOString()
export const toApiDateTime = (value?: Date | null) =>
  value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : null;

const matchesYesNo = (filter: YesNoFilter | undefined, value: boolean) =>
  !filter || filter === YesNoFilter.All || (filter === YesNoFilter.Yes) === value;

const normalize = (value?: string | number | null) =>
  `${value ?? ''}`.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// a lista de lojas é pequena e vem inteira da API, então o filtro é feito no app
export const applyLocationFilter = (locations: ShopLocation[], filter: IFilterToListLocationsOutput) => {
  const text = normalize(filter.text?.trim());
  return locations.filter(location =>
    (!text || normalize(location.name).includes(text) || normalize(location.shopifyId).includes(text))
    && matchesYesNo(filter.omnichannel, location.isOmnichannel === true)
    && matchesYesNo(filter.manageOrderInSislog, location.manageOrderInSislog === true)
    && matchesYesNo(filter.transactionalCommunication, !!location.transactionalCommunicationEnabledSinceDate));
}
